app.controller('ArticleController', ['$scope','$http','Config','$timeout','cart','toaster','article', function($scope,$http,Config,$timeout,cart,toaster,article){

	$scope.relatedProducts = [];
	$scope.base_url = Config.base_url;
	$scope.cart = cart.getCart();
	$scope.init = function(){
		$scope.getRelatedProducts();
	}

	$scope.getRelatedProducts = function(){

		width = 300;
		height = 300;
		articleID = $('#article_id').val();

		article.getRelatedProducts(articleID, width, height).then(function(response) {
				   $scope.relatedProducts = response.data;
				   console.log(articleID);
				   console.log(response.data);
			   	$timeout(function () {
				    $scope.initOwlRelatedProductsSlider();
				    $('#preloader_container').remove();
				}, 100);
			  }, function(response) {
			    console.log(response);
			 });
	}

	$scope.initOwlRelatedProductsSlider = function(){
		$(".related_upsell").each(function(e) { 
			$(this).owlCarousel({
				responsive:{
					0:{
						items:1
					},
					480:{
						items:2
					},
					768:{
						items:3
					},
					1200:{
						items:4
					}
				},
				navigation: true,
				dots: false,
				slideSpeed: 300,
				paginationSpeed: 400,
				loop: true
			});
		});
	}


}]);